<template>
    <div class="modal fade" id="editAccountSettings" tabindex="-1" role="dialog"
         aria-labelledby="editAccountSettingsModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>{{page_header}}</h1>
                </div>
                <div class="modal-body">
                    <div class="row" style="position: relative">
                        <tabs @changed="onTabChange" :options="{ useUrlFragment: false }">
                            <tab name="Account Info">
                                <div style="position:relative;">
                                    <div style="width: 75%;">
                                        <input class="modal-input" type="text" placeholder="E-MAIL" v-model="email"
                                               v-bind:disabled="emailDisabled" style="text-transform: lowercase;"/>
                                        <hr style="width: 100%">
                                    </div>
                                    <div style="width: 25%; height:100%; position: absolute; top:-8px; right:0;"
                                         v-if="open_type == 2 && isRegisteredOrPOCorMSSP()">
                                        <button id="send-email-activation" class="modal-button modal-green-button grow"
                                                @click="sendActivationMailClicked"
                                                v-bind:disabled="sendActivationMailIsDisabled"
                                                style="width: 90%; height: 100%; position: absolute; right:5px;">
                                            {{sendActivationButtonText}}
                                        </button>
                                    </div>
                                </div>
                                <input class="modal-input" type="text" placeholder="FIRST NAME" v-model="firstName"
                                       style="width: 75%"/>
                                <hr>
                                <input class="modal-input" type="text" placeholder="LAST NAME" v-model="lastName"
                                       style="width: 75%"/>
                                <hr>
                                <input class="modal-input" type="text" placeholder="TITLE" v-model="title"
                                       style="width: 75%"/>
                                <hr>
                                <div style="position:relative;">
                                    <div style="width: 75%;" class="mobile-input-container">
                                        <input class="modal-input" type="text" placeholder="MOBILE"
                                               v-bind:disabled="mobileIsDisabled" ref="editAccountSettingsPhoneInput" v-model="phone"/>
                                        <hr style="width: 100%">
                                        <span class="mobile-input-tooltip">Enter counrty code and phone number. Sample for USA: 15417543010</span>
                                    </div>
                                    <div style="width: 25%; height:100%; position: absolute; top:-8px; right:0;">
                                        <button id="send-verification" class="modal-button modal-green-button grow"
                                                @click="sendVerificationClicked"
                                                v-bind:disabled="sendVerificationButtonIsDisabled"
                                                style="width: 90%; height: 100%; position: absolute; right:5px;">
                                            {{sendVerificationButtonText}}
                                        </button>
                                    </div>
                                </div>
                                <div v-show="verificationPanelVisibility" style="position:relative;">
                                    <div style="width: 75%;">
                                        <input class="modal-input" type="text" placeholder="CODE"
                                               v-model="verificationCode"/>
                                        <hr style="width: 100%">
                                    </div>
                                    <div style="width: 25%; height:100%; position: absolute; top:-8px; right:0;">
                                        <button class="modal-button modal-green-button grow"
                                                style="width: 90%; height: 100%; position: absolute; right:5px;"
                                                @click="verifyClicked">VERIFY
                                        </button>
                                    </div>
                                </div>
                                <div style="position: relative;">
                                    <div style="width: 75%;">
                                        <label class="checkbox-text modal-input">
                                            <input id="chkTwoFactor" type="checkbox"
                                                   v-bind:disabled="twoFactorCheckIsDisabled || isGoogleVerified"
                                                   v-model="twoFactorAuth"/>2 FACTOR AUTHENTICATION BY SMS
                                        </label>
                                        <hr style="width: 100%">
                                    </div>
                                    <div style="width: 25%; height:100%; position: absolute; top:-8px; right:0;">
                                        <label v-show="verificationPanelVisibility && !phone_verified"
                                               class="checkbox-text"
                                               style="position:absolute; bottom: 0; top:0; margin:auto; right:10px; max-width: 150px; height: 58px;"
                                               id="lblNotifier">Please wait {{counter}} seconds to send a new
                                            code.</label>
                                        <button class="modal-button modal-green-button grow"
                                                style="width: 90%; height: 110%; position: absolute; right:5px;"
                                                v-show="phone_verified"
                                                @click="subscribeTelegramClicked">SUBSCRIBE TELEGRAM BOT
                                        </button>
                                    </div>
                                </div>
                                <div style="position: relative; height: 40px">
                                    <div style="position: relative;  width: 75%; margin-right: 0px;">
                                        <label class="checkbox-text modal-input">
                                            <input id="chkTwoFactorGoogle" type="checkbox"
                                                   v-model="twoFactorAuthGoogle"
                                                   v-bind:disabled="isGoogleVerified || twoFactorAuth"
                                                   @click="generateGoogleAuthLink"/>2 FACTOR AUTHENTICATION BY GOOGLE
                                            AUTHENTICATOR
                                        </label>
                                        <div v-show="showQRCode"
                                             style="width: 70%;background-color: white; margin: 0 auto;">
                                            <label style="padding-left: 5px;">For Manuel Entry: {{s_key}}</label>
                                            <br>
                                            <img alt="qrcode" class="js-qrcode qrcode" width="125" height="125"
                                                 :src=googleAuthLink>
                                            <input type="text" placeholder="Authenticator Code"
                                                   v-model="googleVerifyCode"/>
                                            <button class="modal-button modal-green-button grow"
                                                    @click="verifyGoogleAuth">VERIFY
                                            </button>
                                        </div>
                                    </div>
                                    <div v-show="isGoogleVerified"
                                         style="width: 25%; height: 100%; position: absolute; top:-8px; right:0;">
                                        <button class="modal-button modal-green-button"
                                                @click="sendVerificationClicked"
                                                v-bind:disabled="true"
                                                style="width: 90%; height: 100%; position: absolute; right:5px;">
                                            VERIFIED
                                        </button>
                                    </div>
                                </div>
                            </tab>
                            <tab name="Threat Permissions">
                                <table class="permissionTable">
                                    <tr class="tableRow">
                                        <th class="emptyTableHeader">Select All Permissions</th>
                                        <th class="tableHeader" colspan="2">Notification Permissions</th>
                                        <th class="tableHeader" colspan="2">Global Permissions</th>
                                        <th class="tableHeader" colspan="2">Partner Permissions</th>
                                        <th class="tableHeader" colspan="2">Industry Permissions</th>
                                    </tr>
                                    <tr class="tableRow">
                                        <th class="emptyTableHeader">Select All <br> <input
                                            class="permission notification-ui-checkbox" type="checkbox"
                                            @click="toggleAllSelect()" name="doo"/></th>
                                        <th class="tableHeader">UI Access <br> <input
                                            class="permission notification-ui-checkbox" type="checkbox"
                                            @click="handlerFunctionsAll(notfUI)" name="notfUI"/></th>
                                        <th class="tableHeader">CSV Export <br> <input
                                            class="permission notification-export-checkbox" type="checkbox"
                                            @click="handlerFunctionsAll(notfExport)" name="notfExport"/></th>
                                        <th class="tableHeader">UI Access <br> <input
                                            class="permission global-ui-checkbox" type="checkbox"
                                            @click="handlerFunctionsAll(globalUI)" name="globalUI"/></th>
                                        <th class="tableHeader">CSV Export <br> <input
                                            class="permission global-export-checkbox" type="checkbox"
                                            @click="handlerFunctionsAll(globalExport)" name="globalExport"/></th>
                                        <th class="tableHeader">UI Access <br> <input
                                            class="permission partner-ui-checkbox" type="checkbox"
                                            @click="handlerFunctionsAll(partnerUI)" name="partnerUI"/></th>
                                        <th class="tableHeader">CSV Export <br> <input
                                            class="permission partner-export-checkbox" type="checkbox"
                                            @click="handlerFunctionsAll(partnerExport)" name="partnerExport"/></th>
                                        <th class="tableHeader">UI Access <br> <input
                                            class="permission industry-ui-checkbox" type="checkbox"
                                            @click="handlerFunctionsAll(industryUI)" name="industryUI"/></th>
                                        <th class="tableHeader">CSV Export <br> <input
                                            class="permission industry-export-checkbox" type="checkbox"
                                            @click="handlerFunctionsAll(industryExport)" name="industryExport"/></th>
                                    </tr>
                                    <tr class="tableRow" v-for="page in threat_permission_pages">
                                        <td class="tableData">{{page.name}}</td>
                                        <td class="tableDataCheckBox">
                                            <input class="permission notification-ui-checkbox" type="checkbox"
                                                   :value="page.id"
                                                   name="foo"
                                                   @click="handlerFunctions(notfUI)"
                                            />
                                        </td>
                                        <td class="tableDataCheckBox">
                                            <input class="permission notification-export-checkbox" type="checkbox"
                                                   :value="page.id"
                                                   name="foo"
                                                   @click="handlerFunctions(notfExport)"
                                            />
                                        </td>
                                        <td class="tableDataCheckBox">
                                            <input v-if="isStolen(page.id)" class="permission global-ui-checkbox"
                                                   type="checkbox"
                                                   :value="page.id"
                                                   name="foo"
                                                   @click="handlerFunctions(globalUI)"
                                            />
                                        </td>
                                        <td class="tableDataCheckBox">
                                            <input v-if="isStolen(page.id)" class="permission global-export-checkbox"
                                                   type="checkbox"
                                                   :value="page.id"
                                                   name="foo"
                                                   @click="handlerFunctions(globalExport)"
                                            />
                                        </td>
                                        <td class="tableDataCheckBox">
                                            <input class="permission partner-ui-checkbox"
                                                   type="checkbox"
                                                   :value="page.id"
                                                   name="foo"
                                                   @click="handlerFunctions(partnerUI)"
                                            />
                                        </td>
                                        <td class="tableDataCheckBox">
                                            <input class="permission partner-export-checkbox"
                                                   type="checkbox"
                                                   :value="page.id"
                                                   name="foo"
                                                   @click="handlerFunctions(partnerExport)"
                                            />
                                        </td>
                                        <td class="tableDataCheckBox">
                                            <input v-if="isStolen(page.id)" class="permission industry-ui-checkbox"
                                                   type="checkbox"
                                                   :value="page.id"
                                                   name="foo"
                                                   @click="handlerFunctions(industryUI)"
                                            />
                                        </td>
                                        <td class="tableDataCheckBox">
                                            <input v-if="isStolen(page.id)" class="permission industry-export-checkbox"
                                                   type="checkbox"
                                                   :value="page.id"
                                                   name="foo"
                                                   @click="handlerFunctions(industryExport)"
                                            />
                                        </td>
                                    </tr>
                                </table>
                            </tab>
                            <tab name="Settings Permissions">
                                <table class="permissionTable">
                                    <tr class="tableRow">
                                        <th class="emptyTableHeader">Select All<br> <input
                                            class="permission settings-ui-checkbox" type="checkbox"
                                            @click="toggleAllSelectSettingsPermission()" name="goo"/>
                                        </th>
                                        <th class="tableHeader">UI Access<br> <input
                                            class="permission settings-ui-checkbox" type="checkbox"
                                            @click="handlerFunctionsAllSettings(settingsUI)" name="settingsUI"/>
                                        </th>
                                        <th class="tableHeader">CSV Export<br> <input
                                            class="permission settings-export-checkbox" type="checkbox"
                                            @click="handlerFunctionsAllSettings(settingsExport)" name="settingsExport"/>
                                        </th>
                                    </tr>
                                    <tr class="tableRow" v-for="page in settings_pages">
                                        <td class="tableData">{{page.name}}</td>
                                        <td class="tableDataCheckBox">
                                            <input class="permission settings-ui-checkbox" type="checkbox"
                                                   :value="page.id"
                                                   name="boo"
                                                   @click="handlerFunctionsSettings(settingsUI, page.id)"
                                            />
                                        </td>
                                        <td class="tableDataCheckBox">
                                            <input v-if="isAntivirusVendor(page.id)"
                                                   class="permission settings-export-checkbox"
                                                   type="checkbox" :value="page.id"
                                                   name="boo"
                                                   @click="handlerFunctionsSettings(settingsExport, page.id)"
                                            />
                                        </td>
                                    </tr>
                                </table>
                            </tab>
                        </tabs>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="modal-footer-container">
                        <button class="modal-button modal-red-button grow" @click="cancelClicked">CANCEL</button>
                        <button class="modal-button modal-green-button grow" @click="saveClicked">SAVE</button>
                    </div>
                </div>
                <confirm-popup-modal ref="sendActivationConfirmPopupModal"
                                     @okClicked="sendActivationConfirmPopUpConfirmClicked"
                                     :modalName="'sendActivationConfirmPopupModal'"/>
            </div>

        </div>
        <loading-modal v-if="loading"/>
    </div>

</template>

<script>
    import Constants from '@/utils/constants'
    import LoadingModal from '@/components/modals/LoadingModal.vue'
    import Common from '@/utils/Common.vue';
    import ConfirmPopupModal from '@/components/modals/ConfirmPopupModal.vue'
    import {mapGetters} from 'vuex';

    const CHECKBOX_NAMES = [
        "notfUI",
        "notfExport",
        "globalUI",
        "globalExport",
        "partnerUI",
        "partnerExport",
        "industryUI",
        "industryExport",
        "settingsUI",
        "settingsExport"
    ];

    //Open Types
    const OPEN_TYPE_INSERT = 1;
    const OPEN_TYPE_EDIT = 2;
    //Tab Constants
    const TAB_NOTIFICATION = 'Notification Permissions';
    const TAB_GLOBAL = 'Global Permissions';
    const TAB_SETTINGS = 'Settings Permissions';
    const TAB_PARTNER = 'Partner Permissions';
    //Tab Types
    const TAB_TYPE_NOTIFICATION = 1;
    const TAB_TYPE_GLOBAL = 2;
    const TAB_TYPE_SETTINGS = 3;
    const TAB_TYPE_PARTNER = 4;

    const SEND_ACTIVATION_ENDPOINT = '/enterprise/resend/activation';
    const VERIFY_GOOGLE_ENDPOINT = '/verify/google/auth';
    const S_KEY_ENDPOINT = '/google/key/get';

    export default {
        name: "edit-account-settings",
        components: {
            LoadingModal: LoadingModal,
            ConfirmPopupModal: ConfirmPopupModal
        },
        mixins: [Common],
        data() {
            return {
                //Check box names
                notfUI: 'notfUI',
                notfExport: 'notfExport',
                globalUI: 'globalUI',
                globalExport: 'globalExport',
                partnerUI: 'partnerUI',
                partnerExport: 'partnerExport',
                industryUI: 'industryUI',
                industryExport: 'industryExport',
                settingsUI: 'settingsUI',
                settingsExport: 'settingsExport',

                interval: null,
                loading: false,
                message_id: '',
                verificationPanelVisibility: false,
                twoFactorCheckIsDisabled: true,
                mobileIsDisabled: false,
                emailDisabled: false,
                sendVerificationButtonIsDisabled: false,
                sendVerificationButtonText: 'SEND VERIFICATION',
                sendActivationMailIsDisabled: false,
                sendActivationButtonText: 'SEND ACTIVATION',
                counter: 0,

                // inital values
                phone: '',
                twoFactorAuth: false,
                twoFactorAuthGoogle: false,
                showQRCode: false,
                verificationCode: '',
                email: '',
                firstName: '',
                lastName: '',
                title: '',
                id: 0,
                phone_verified: false,
                old_variables: null,
                cat_logger_data: null,

                //Tab Values
                threat_permission_pages: [],
                global_pages: [],
                settings_pages: [],
                partner_pages: [],

                page_header: '',
                open_type: null,
                active_tab: TAB_TYPE_NOTIFICATION,

                //Selected Permission Lists
                notification_permission_list: [],
                global_permission_list: [],
                settings_permission_list: [],
                partner_permission_list: [],

                //Google Auth Key
                s_key: null,
                googleAuthLink: null,
                googleVerifyCode: null,
                isGoogleVerified: false

            }
        },
        beforeDestroy() {
            clearInterval(this.interval);
        },
        methods: {
            isRegisteredOrPOCorMSSP() {
                return this.getEnterpriseStatus == 7 || this.getEnterpriseStatus == 8 || this.getUserRole(this.getComodoAdminRole) == "TI_VI_MSSP_USER";
            },
            verifyGoogleAuth() {
                var body = {
                    s_key: this.s_key,
                    auth_code: this.googleVerifyCode
                };
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + VERIFY_GOOGLE_ENDPOINT, body)
                    .then(() => {
                            this.isGoogleVerified = true;
                            this.showQRCode = false;
                            this.$toasted.show("Successfully verified.", {
                                position: "bottom-center",
                                duration: 3000,
                                type: 'success'
                            });
                        }, error => {
                            this.$toasted.show("Request error, please try again.", {
                                position: "bottom-center",
                                duration: 3000,
                                type: 'error'
                            });
                        }
                    );
            },
            isStolen(pageId) {
                if (pageId != 2 && pageId != 3 && pageId != 46) {
                    return true;
                } else {
                    return false;
                }
            },
            isAntivirusVendor(pageId) {
                if (pageId != 304) {
                    return true;
                } else {
                    return false;
                }
            },
            sendActivationConfirmPopUpConfirmClicked() {
                this.$refs.sendActivationConfirmPopupModal.hideModal();
                var body = {
                    email: this.email,
                    first_name: this.firstName
                };

                this.cat_logger_data = {};
                this.cat_logger_data.customer_name = this.getEnterpriseName;
                this.cat_logger_data.customer_id = this.getEnterpriseId;
                this.cat_logger_data.account_id = this.id;
                this.cat_logger_data.account_email = this.email.toLowerCase();

                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + SEND_ACTIVATION_ENDPOINT, body)
                    .then(() => {
                            this.cat_logger_data.send_activation = "True";
                            this.saveCatLog(this, Constants.cat_logger.customer_ui_send_activation_cat_logger, this.cat_logger_data);

                            this.$toasted.show("Activation sent.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'success'
                            });
                        }, error => {
                            this.cat_logger_data.send_activation = "False";
                            let errorMessage = "Request error, please try again.";
                            if (error.status === 404) {
                                errorMessage = "User doesn't exists please check mail address."
                            } else if (error.status === 400) {
                                errorMessage = "Please check your parameters."
                            }

                            this.$toasted.show(errorMessage, {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });

                        }
                    );
            },
            getThreatPermissionPages() {
                this.loading = true;
                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/threat_permissions/get', {verbose: false});
                promise.then(function (response) {
                    this.loading = false;
                    this.threat_permission_pages = response.data.data;
                }, function () {
                    this.loading = false;
                    this.threat_permission_pages = [];
                    // console.log("Error occurred when at get threat_permissions request");
                });
            },
            getSettingsPages() {
                this.loading = true;
                let promise = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/settings_permissions/get', {verbose: false});
                promise.then(function (response) {
                    this.loading = false;
                    this.settings_pages = response.data.data;
                }, function () {
                    this.loading = false;
                    this.settings_pages = [];
                    // console.log("Error occurred when at get settings_permissions request");
                });
            },
            subscribeTelegramClicked() {
                var body = {
                    phone: this.phone
                };
                this.cat_logger_data = {};
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/subscribe/telegram', body)
                    .then(response => {
                        this.cat_logger_data.customer_name = this.getEnterpriseName;
                        this.cat_logger_data.customer_id = this.getEnterpriseId;
                        this.cat_logger_data.account_id = this.phone;
                        this.cat_logger_data.account_email = this.email.toLowerCase();
                        this.cat_logger_data.subscribe_telegram_bot = "True";

                        this.saveCatLog(this, Constants.cat_logger.customer_ui_subscribe_telegram_bot_cat_logger, this.cat_logger_data);

                        this.$toasted.show("Subscribe SMS sent.", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'success'
                        });
                    }, response => {
                        this.$toasted.show("Request error, please try again.", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    })
            },
            permissionChecked(id) {
                var index = -1;
                if (this.active_tab == TAB_TYPE_NOTIFICATION) {
                    index = this.notification_permission_list.indexOf(id);
                    if (index != -1) {
                        this.notification_permission_list.splice(index, 1);
                    } else {
                        this.notification_permission_list.push(id);
                    }
                } else if (this.active_tab == TAB_TYPE_GLOBAL) {
                    index = this.global_permission_list.indexOf(id);
                    if (index != -1) {
                        this.global_permission_list.splice(index, 1);
                    } else {
                        this.global_permission_list.push(id);
                    }
                } else if (this.active_tab == TAB_TYPE_SETTINGS) {
                    index = this.settings_permission_list.indexOf(id);
                    if (index != -1) {
                        this.settings_permission_list.splice(index, 1);
                    } else {
                        this.settings_permission_list.push(id);
                    }
                } else if (this.active_tab == TAB_TYPE_PARTNER) {
                    index = this.partner_permission_list.indexOf(id);
                    if (index != -1) {
                        this.partner_permission_list.splice(index, 1);
                    } else {
                        this.partner_permission_list.push(id);
                    }
                }
            },
            onTabChange(data) {
                if (data.tab.name == TAB_NOTIFICATION) {
                    this.active_tab = TAB_TYPE_NOTIFICATION;
                } else if (data.tab.name == TAB_GLOBAL) {
                    this.active_tab = TAB_TYPE_GLOBAL;
                } else if (data.tab.name == TAB_SETTINGS) {
                    this.active_tab = TAB_TYPE_SETTINGS;
                } else if (data.tab.name == TAB_PARTNER) {
                    this.active_tab = TAB_TYPE_PARTNER;
                }
            },
            showModal(row) {
                this.setInitialValues();
                if (row != null) {
                    this.getPermissions(row.id);
                    this.open_type = OPEN_TYPE_EDIT;
                    this.page_header = 'Edit Account';
                    this.verificationCode = '';
                    this.setInitialState();
                    this.$nextTick(function () {
                        this.id = row.id;
                        this.phone = row.phone === 'None' ? '' : row.phone;
                        this.twoFactorAuth = row.two_factor_auth === 'None' || row.two_factor_auth === 'False' ? false : true;
                        this.verificationPanelVisibility = false;
                        this.firstName = row.first_name;
                        this.email = row.email;
                        this.lastName = row.last_name;

                        if (row.title != undefined && row.title != null && row.title != 'None') {
                            this.title = row.title;
                        } else {
                            this.title = '';
                        }

                        if (row.phone_verified === 'True') {
                            this.setVerifiedState();
                        } else {
                            this.mobileIsDisabled = false;
                            this.sendVerificationButtonIsDisabled = false;
                        }

                        this.emailDisabled = true;

                        if (row.google_verified === 'True') {
                            this.showQRCode = false;
                            this.isGoogleVerified = true;
                            this.twoFactorAuthGoogle = true;
                        } else {
                            if (row.secret_key != null && row.secret_key.length > 0) {
                                this.s_key = row.secret_key;
                            }
                        }
                        $('#editAccountSettings').modal('show');
                        this.old_variables = {
                            title: row.title,
                            first_name: row.first_name,
                            last_name: row.last_name,
                        }
                    });
                } else {
                    this.open_type = OPEN_TYPE_INSERT;
                    this.page_header = 'Add Account';
                    $('#editAccountSettings').modal('show');
                }

            },
            hideModal() {
                $('#editAccountSettings').modal('hide');
            },
            generateGoogleAuthLink() {
                if ($("#chkTwoFactorGoogle").prop("checked")) {
                    if (this.validateEmail(this.email)) {
                        this.googleAuthLink = "https://chart.googleapis.com/chart?chs=125x125&chld=L|0&cht=qr&chl=otpauth://totp/COMODO:"
                        this.googleAuthLink = this.googleAuthLink + this.email + "?secret=" + this.s_key + "&issuer=COMODO";
                        this.showQRCode = true;
                    } else {
                        this.showQRCode = false;
                        $("#chkTwoFactorGoogle").prop("checked", false);
                        this.$toasted.show("Please insert a valid email and try again.", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    }
                } else {
                    this.showQRCode = false;
                    $("#chkTwoFactorGoogle").prop("checked", false);
                }
            },
            getPermissions(id) {
                var body = {
                    id: id
                };
                this.loading = true;
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/permission/get', body)
                    .then(response => {
                        if (response.body.return_code === 'Success') {
                            var response_data = response.data.data;
                            this.setPermissions(response_data.notification_permissions, 'notification');
                            this.setPermissions(response_data.global_permissions, 'global');
                            this.setPermissions(response_data.partner_permissions, 'partner');
                            this.setPermissions(response_data.industry_permissions, 'industry');
                            this.setPermissions(response_data.settings_permissions, 'settings');

                        }
                        this.loading = false;
                    }, response => {
                        this.loading = false;
                        this.$toasted.show("Request error, please try again.", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    })
            },
            setPermissions(permissionObj, className) {
                if (permissionObj != undefined) {
                    if (permissionObj.ui_permissions != undefined) {
                        var permissionList = permissionObj.ui_permissions;
                        var checkboxes = document.getElementsByClassName(className + '-ui-checkbox');
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (permissionList.indexOf(checkboxes[i].value) != -1) {
                                checkboxes[i].checked = true;
                            }
                        }
                    }

                    if (permissionObj.export_permissions != undefined) {
                        permissionList = permissionObj.export_permissions;
                        checkboxes = document.getElementsByClassName(className + '-export-checkbox');
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (permissionList.indexOf(checkboxes[i].value) != -1) {
                                checkboxes[i].checked = true;
                            }
                        }
                    }
                }
            },
            setInitialValues() {
                this.interval = null;
                this.loading = false;
                this.message_id = '';
                this.verificationPanelVisibility = false;
                this.twoFactorCheckIsDisabled = true;
                this.mobileIsDisabled = false;
                this.emailDisabled = false;
                this.sendVerificationButtonIsDisabled = false;
                this.sendVerificationButtonText = 'SEND VERIFICATION';
                this.sendActivationButtonText = 'SEND ACTIVATION';
                this.counter = 0;
                this.phone = '';
                this.twoFactorAuth = false;
                this.twoFactorAuthGoogle = false;
                this.verificationCode = '';
                this.email = '';
                this.firstName = '';
                this.lastName = '';
                this.title = '';
                this.id = 0;
                this.phone_verified = false;
                this.global_pages = [];
                this.partner_pages = [];
                this.page_header = '';
                this.open_type = null;
                this.clearPermissionCheckboxes();
            },
            clearPermissionCheckboxes() {
                var checkboxes = document.getElementsByClassName('permission');
                for (var i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].checked = false;
                }
            },
            sendActivationMailClicked() {
                this.$refs.sendActivationConfirmPopupModal.showModal('A new activation mail will be delivered to the user. Are you sure?');
            },
            sendVerificationClicked() {
                if (this.phone && $.isNumeric(this.phone)) {
                    this.loading = true;
                    this.cat_logger_data = {};
                    var reqSendNotification = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL +
                        '/enterprise/account/sendtwofactorauthphonesms', {id: this.id, mobile: this.phone});
                    reqSendNotification.then(
                        function (result) {
                            let result_body = result.body.data;
                            if (result_body[0] === true) {

                                this.cat_logger_data.account_email = this.email.toLowerCase();
                                this.cat_logger_data.verification = "SMS: " + this.phone;
                                this.cat_logger_data.customer_name = this.getEnterpriseName;
                                this.cat_logger_data.customer_id = this.getEnterpriseId;
                                this.cat_logger_data.account_id = this.id;

                                this.message_id = result_body[1];
                                this.mobileIsDisabled = true;
                                this.sendVerificationButtonIsDisabled = true;

                                this.counter = 180;
                                if (this.interval != null) {
                                    clearInterval(this.interval);
                                }

                                this.verificationPanelVisibility = true;
                                var self = this;
                                this.interval = setInterval(function () {


                                    if (self.counter == 1) {
                                        self.verificationPanelVisibility = false;
                                        self.mobileIsDisabled = false;
                                        self.sendVerificationButtonIsDisabled = false;

                                        clearInterval(self.interval);
                                    }

                                    self.counter--;


                                }, 1000);
                            } else {
                                $('#lblNotifier').html("There is an error during sending verification process. Please try again later.")
                            }


                            this.loading = false;
                        }, function (result) {
                            $('#lblNotifier').html("There is an error during sending verification process. Please try again later.")
                        }
                    );
                }
            },
            verifyClicked() {
                var code = this.verificationCode;
                if (code) {
                    this.loading = true;
                    var reqCodeVerify = this.$http.post(Constants.INTELLIGENCE_BACKEND_URL
                        + '/enterprise/account/smscodeverification', {
                        id: this.id,
                        message_id: this.message_id,
                        code: this.verificationCode,
                        mobile: this.phone
                    });
                    reqCodeVerify.then(function (result) {
                        this.verificationPanelVisibility = false;
                        this.setVerifiedState();
                        clearInterval(this.interval);
                        this.$emit("operationCompleted");
                        this.loading = false;
                        this.cat_logger_data.verification_status = "True";
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_verification_cat_logger, this.cat_logger_data);
                    }, function (result) {
                        this.cat_logger_data.verification_status = "False";
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_verification_cat_logger, this.cat_logger_data);
                        this.loading = false;
                        if (result.status === 400) {
                            this.$toasted.show("Verification code is invalid. Please check again.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        } else {
                            this.$toasted.show("Server Error. Please check again.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                    });
                }

            },
            createPermissionJSON() {
                var permissions = {};
                permissions['notification_permissions'] = this.createPermissionByClass('notification');
                permissions['global_permissions'] = this.createPermissionByClass('global');
                permissions['partner_permissions'] = this.createPermissionByClass('partner');
                permissions['industry_permissions'] = this.createPermissionByClass('industry');
                permissions['settings_permissions'] = this.createPermissionByClass('settings');

                return permissions;
            },
            createPermissionByClass(className) {
                var permissionObj = {};
                var uiPermissionList = [];
                var exportPermissionList = [];
                var checkboxes = document.getElementsByClassName(className + '-ui-checkbox');
                for (var i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i].checked) {
                        uiPermissionList.push(checkboxes[i].value);
                    }
                }
                checkboxes = document.getElementsByClassName(className + '-export-checkbox');
                for (var i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i].checked) {
                        exportPermissionList.push(checkboxes[i].value);
                    }
                }
                permissionObj['ui_permissions'] = uiPermissionList;
                permissionObj['export_permissions'] = exportPermissionList;

                return permissionObj;
            },
            validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            saveClicked() {
                if (!this.email || !this.validateEmail(this.email)) {
                    this.showErrorMessage('Please enter your e-mail address.');
                    return;
                }

                if (!this.firstName) {
                    this.showErrorMessage('Please enter your first name.');
                    return;
                }

                if (!this.lastName) {
                    this.showErrorMessage('Please enter your last name.');
                    return;
                }

                var body = {
                    phone: this.phone,
                    twoFactorAuth: this.twoFactorAuth,
                    id: this.id,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email.toLowerCase(),
                    title: this.title,
                    phone_verified: this.phone_verified,
                    permissions: this.createPermissionJSON(),
                    s_key: this.s_key,
                    google_verified: this.isGoogleVerified
                };

                this.loading = true;
                if (this.open_type == OPEN_TYPE_EDIT) {
                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/account/savev2user', body)
                        .then(response => {
                            if (response.body.return_code === 'Success') {
                                this.$emit("operationCompleted");
                                $('#editAccountSettings').modal('hide');
                                this.$toasted.show("Account edited successfully", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'success'
                                });
                                this.cat_logger_data = this.old_variables;
                                this.cat_logger_data.updated_title = this.title;
                                this.cat_logger_data.account_email = this.email.toLowerCase();
                                this.cat_logger_data.customer_name = this.getEnterpriseName;
                                this.cat_logger_data.authentication_by = this.phone_verified ? "SMS" : "";
                                this.cat_logger_data.authentication_by = this.isGoogleVerified ? "GOOGLE" : "";
                                this.cat_logger_data.updated_last_name = this.lastName;
                                this.cat_logger_data.updated_first_name = this.firstName;
                                this.cat_logger_data.customer_id = this.getEnterpriseId;
                                this.cat_logger_data.account_id = this.id;
                                this.saveCatLog(this, Constants.cat_logger.customer_ui_edit_account_cat_logger, this.cat_logger_data);
                            } else if (response.body.return_code === 'SERVER ERROR') {
                                this.$toasted.show("Error has occurred during enterprise domain check.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else if (response.body.return_code === 'DB ERROR') {
                                this.$toasted.show("Error has occurred during controls.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else if (response.body.return_code === 'Integity ERROR') {
                                this.$toasted.show("The e-mail address is already registered.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else if (response.body.return_code === 'EMAIL NOT BELONG TO ENTERPRISE ERROR') {
                                this.$toasted.show("E-mail doesn't belong to enterprise account, please try again with different e-mail.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else {
                                this.$toasted.show("Request error, please try again.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            }
                            this.loading = false;
                        }, response => {
                            this.$toasted.show("Request error, please try again.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                            this.loading = false;
                        })
                } else {
                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/account/addv2user', body)
                        .then(response => {
                            if (response.body.return_code === 'Success') {
                                this.$emit("operationCompleted");
                                $('#editAccountSettings').modal('hide');
                                this.$toasted.show("Account inserted successfully", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'success'
                                });
                                this.cat_logger_data = {};
                                this.cat_logger_data.customer_name = this.getEnterpriseName;
                                this.cat_logger_data.customer_id = this.getEnterpriseId;
                                this.cat_logger_data.authentication_by = this.phone_verified ? "SMS" : "";
                                this.cat_logger_data.authentication_by = this.isGoogleVerified ? "GOOGLE" : "";
                                this.cat_logger_data.title = this.title;
                                this.cat_logger_data.last_name = this.lastName;
                                this.cat_logger_data.first_name = this.firstName;
                                this.cat_logger_data.email = this.email.toLowerCase();
                                this.cat_logger_data.added_email = this.email.toLowerCase();
                                this.cat_logger_data.mobile_number = this.phone;
                                this.cat_logger_data.primary = false;
                                this.cat_logger_data.added_account_id = response.body.data.new_user_id;
                                this.saveCatLog(this, Constants.cat_logger.customer_ui_add_account_cat_logger, this.cat_logger_data);

                            } else if (response.body.return_code === 'SERVER ERROR') {
                                this.$toasted.show("Error has occurred during enterprise domain check.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else if (response.body.return_code === 'DB ERROR') {
                                this.$toasted.show("Error has occurred during controls.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else if (response.body.return_code === 'Integity ERROR') {
                                this.$toasted.show("The e-mail address is already registered.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else if (response.body.return_code === 'EMAIL NOT BELONG TO ENTERPRISE ERROR') {
                                this.$toasted.show("E-mail doesn't belong to enterprise account, please try again with different e-mail.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            } else {
                                this.$toasted.show("Request error, please try again.", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            }
                            this.loading = false;
                        }, response => {
                            this.$toasted.show("Request error, please try again.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                            this.loading = false;
                        })
                }
            },
            cancelClicked() {
                $('#editAccountSettings').modal('hide');
            },
            setVerifiedState() {
                this.mobileIsDisabled = true;
                this.twoFactorCheckIsDisabled = false;
                this.sendVerificationButtonIsDisabled = true;
                this.phone_verified = true;
                $('#send-verification').removeClass("grow");
                this.sendVerificationButtonText = "VERIFIED";
            },
            setInitialState() {
                this.mobileIsDisabled = false;
                this.twoFactorCheckIsDisabled = true;
                this.sendVerificationButtonIsDisabled = false;
                this.sendVerificationButtonText = "SEND VERIFICATION";
                this.sendActivationButtonText = "SEND ACTIVATION";
            },
            toggleAllSelect() {
                //Select All Function
                let checkboxes = document.getElementsByName('foo');
                let selectAll = document.getElementsByName('doo');
                if (selectAll[0].checked === true) {
                    for (var i = 0; i < checkboxes.length; i++) {
                        checkboxes[i].checked = true;
                    }
                    //Other Checkbox to be true
                    for (var j = 0; j < CHECKBOX_NAMES.length; j++) {
                        let selectOther = document.getElementsByName(CHECKBOX_NAMES[j]);
                        selectOther[0].checked = true;
                    }
                } else if (selectAll[0].checked === false) {
                    for (var i = 0; i < checkboxes.length; i++) {
                        checkboxes[i].checked = false;
                    }
                    //Other Checkbox to be false
                    for (var j = 0; j < CHECKBOX_NAMES.length; j++) {
                        let selectOther = document.getElementsByName(CHECKBOX_NAMES[j]);
                        selectOther[0].checked = false;
                    }
                }
            },
            toggleAllSelectSettingsPermission() {
                //Select All Function
                let checkboxes = document.getElementsByName('boo');
                let selectAll = document.getElementsByName('goo');
                if (selectAll[0].checked === true) {
                    for (var i = 0; i < checkboxes.length; i++) {
                        checkboxes[i].checked = true;
                    }
                    //Other Checkbox to be true
                    for (var j = 0; j < CHECKBOX_NAMES.length; j++) {
                        let selectOther = document.getElementsByName(CHECKBOX_NAMES[j]);
                        selectOther[0].checked = true;
                    }
                } else if (selectAll[0].checked === false) {
                    for (var i = 0; i < checkboxes.length; i++) {
                        checkboxes[i].checked = false;
                    }
                    //Other Checkbox to be false
                    for (var j = 0; j < CHECKBOX_NAMES.length; j++) {
                        let selectOther = document.getElementsByName(CHECKBOX_NAMES[j]);
                        selectOther[0].checked = false;
                    }
                }
            },
            toggleAllUIExport(status) {
                let checkboxes = document.getElementsByName('foo');
                if (status === this.notfUI) {
                    let selectNotfAll = document.getElementsByName('notfUI');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'notification-ui-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'notification-ui-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    }
                } else if (status === this.notfExport) {
                    let selectNotfAll = document.getElementsByName('notfExport');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'notification-export-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'notification-export-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    }
                } else if (status === this.globalUI) {
                    let selectNotfAll = document.getElementsByName('globalUI');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'global-ui-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'global-ui-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    }
                } else if (status === this.globalExport) {
                    let selectNotfAll = document.getElementsByName('globalExport');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'global-export-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'global-export-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    }
                } else if (status === this.partnerUI) {
                    let selectNotfAll = document.getElementsByName('partnerUI');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'partner-ui-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'partner-ui-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    }
                } else if (status === this.partnerExport) {
                    let selectNotfAll = document.getElementsByName('partnerExport');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'partner-export-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'partner-export-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    }
                } else if (status === this.industryUI) {
                    let selectNotfAll = document.getElementsByName('industryUI');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'industry-ui-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'industry-ui-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    }
                } else if (status === this.industryExport) {
                    let selectNotfAll = document.getElementsByName('industryExport');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'industry-export-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'industry-export-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatus();
                    }
                }
            },
            toggleAllUIExportSettingsPermission(status) {
                let checkboxes = document.getElementsByName('boo');
                if (status === this.settingsUI) {
                    let selectNotfAll = document.getElementsByName('settingsUI');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'settings-ui-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatusSettings();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'settings-ui-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatusSettings();
                    }
                }
                else if (status === this.settingsExport) {
                    let selectNotfAll = document.getElementsByName('settingsExport');

                    if (selectNotfAll[0].checked === true) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'settings-export-checkbox') {
                                checkboxes[i].checked = true;
                            }
                        }
                        this.allSelectCheckBoxStatusSettings();
                    } else if (selectNotfAll[0].checked === false) {
                        for (var i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList[1] === 'settings-export-checkbox') {
                                checkboxes[i].checked = false;
                            }
                        }
                        this.allSelectCheckBoxStatusSettings();
                    }
                }
            },
            statusCheckBox(status) {
                //Set initial UI/Export Checkbox status
                let checkboxes = document.getElementsByName('foo');
                if (status === this.notfUI) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('notfUI');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'notification-ui-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                } else if (status === this.notfExport) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('notfExport');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'notification-export-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                } else if (status === this.globalUI) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('globalUI');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'global-ui-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                } else if (status === this.globalExport) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('globalExport');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'global-export-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                } else if (status === this.partnerUI) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('partnerUI');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'partner-ui-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                } else if (status === this.partnerExport) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('partnerExport');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'partner-export-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                } else if (status === this.industryUI) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('industryUI');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'industry-ui-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                } else if (status === this.industryExport) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('industryExport');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'industry-export-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                }
            },
            statusCheckBoxSettings(status, pageId) {
                //Set initial UI/Export Checkbox status
                let checkboxes = document.getElementsByName('boo');
                if (status === this.settingsUI) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('settingsUI');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'settings-ui-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                }
                else if (status === this.settingsExport) {
                    let checkboxStatus = false;
                    let selectNotfAll = document.getElementsByName('settingsExport');
                    for (var i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList[1] === 'settings-export-checkbox') {
                            if (checkboxes[i].checked === true) {
                                checkboxStatus = true;
                            } else {
                                checkboxStatus = false;
                                break;
                            }
                        }
                    }
                    selectNotfAll[0].checked = checkboxStatus;
                }
            },
            allSelectCheckBoxStatus() {
                //Set initial all selection Checkbox status
                let checkboxes = document.getElementsByName('foo');
                let selectNotfAll = document.getElementsByName('doo');
                let checkboxStatus = false;

                for (var i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i].checked === true) {
                        checkboxStatus = true;
                    } else {
                        checkboxStatus = false;
                        break;
                    }
                }
                selectNotfAll[0].checked = checkboxStatus
            },
            allSelectCheckBoxStatusSettings() {
                //Set initial all selection Checkbox status
                let checkboxes = document.getElementsByName('boo');
                let selectNotfAll = document.getElementsByName('goo');
                let checkboxStatus = false;

                for (var i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i].checked === true) {
                        checkboxStatus = true;
                    } else {
                        checkboxStatus = false;
                        break;
                    }
                }
                selectNotfAll[0].checked = checkboxStatus
            },
            handlerFunctions(status) {
                this.allSelectCheckBoxStatus();
                this.statusCheckBox(status);
            },
            handlerFunctionsAll(status) {
                this.toggleAllUIExport(status);
            },
            handlerFunctionsAllSettings(status) {
                this.toggleAllUIExportSettingsPermission(status)
            },
            handlerFunctionsSettings(status, pageId) {
                this.allSelectCheckBoxStatusSettings();
                this.statusCheckBoxSettings(status, pageId);
            },
            updateAfterCallStatusCheckBox() {
                for (let i = 0; i < CHECKBOX_NAMES.length; i++) {
                    this.statusCheckBox(CHECKBOX_NAMES[i]);
                }
            }
        },
        computed: {
            ...mapGetters([
                "getEnterpriseStatus",
                "getComodoAdminRole",
                "getEnterpriseId",
                "getEnterpriseName"
            ])
        },
        updated: function () {
            this.allSelectCheckBoxStatus();
            this.allSelectCheckBoxStatusSettings();
            this.updateAfterCallStatusCheckBox();
        },
        mounted() {

        },
        beforeMount() {
            this.getThreatPermissionPages();
            this.getSettingsPages();

            var body = {}
            this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + S_KEY_ENDPOINT, body)
                .then(response => {
                    if (response.body.data != null) {
                        this.s_key = response.body.data;
                    }
                }, response => {

                })
        }
    }
</script>

<style scoped>
    input :focus{
        border: 1px solid #FF0047;
    }
    .mobile-input-container {
        position: relative;
        display: inline-block;
    }

    .mobile-input-container .mobile-input-tooltip {
        font-family: 'Digital-Serial-Regular';
        visibility: hidden;
        width: 500px;
        background-color: rgb(0, 0, 0);
        color: #fff;
        text-align: center;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 130%;
        left: 20%;
        margin-left: -60px;
        opacity: 0;
        transition: opacity 0.3s;
        font-size: 15px;

    }

    .mobile-input-container:hover .mobile-input-tooltip {
        visibility: visible;
        opacity: 1;
    }

    .mobile-input-tooltip {
        border: 1px solid #00FFAB;
    }

    .tab-checkbox {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 20px;
        width: 31%;
        height: 30px;
        font-family: 'Digital-Serial-Regular';
        color: rgba(0, 255, 169, 1);
    }

    #send-verification {
        position: absolute;
        right: 2%;
        width: 140px;
    }

    #verify-button {
        position: absolute;
        right: 2%;
        bottom: 3%;
        width: 140px;
    }

    .checkbox-text {
        font-family: 'Digital-Serial-Regular';
        color: rgba(0, 255, 169, 1);
        vertical-align: middle;
        cursor: pointer;
    }

    .error-text {
        font-family: 'Digital-Serial-Regular';
        color: red;
    }

    .verify-button {
        font-family: 'Digital-Serial-Bold';
        padding: 5px 15px;
        background-color: rgba(0, 255, 169, 1);
        border: 1px solid rgba(0, 255, 169, 1);
        border-radius: 2px;
        color: rgba(52, 63, 73, 1);
        cursor: pointer;
        width: 100%;
    }

    .save-button {
        font-family: 'Digital-Serial-Bold';
        padding: 5px 15px;
        background-color: rgba(0, 255, 169, 1);
        border: 1px solid rgba(0, 255, 169, 1);
        border-radius: 2px;
        font-size: 1.5em;
        color: rgba(52, 63, 73, 1);
        cursor: pointer;
        width: 45%;
    }

    .cancel-button {
        font-family: 'Digital-Serial-Bold';
        padding: 5px 15px;
        background-color: rgba(0, 255, 169, 1);
        border: 1px solid rgba(0, 255, 169, 1);
        border-radius: 2px;
        font-size: 1.5em;
        color: rgba(52, 63, 73, 1);
        cursor: pointer;
        width: 45%;
    }

    .verify-button:disabled {
        background-color: rgb(73, 80, 90);
        border: 1px solid rgb(73, 80, 90);
        cursor: default;
    }

    .modal {
        text-align: center;
    }

    @media screen and (min-width: 768px) {
        .modal:before {
            display: inline-block;
            vertical-align: middle;
            content: " ";
            height: 100%;
        }
    }

    .modal-dialog {
        display: inline-block;
        text-align: left;
        vertical-align: middle;
    }

    .modal-dialog {
        background-color: transparent;
    }

    .settings-input {
        background-color: transparent;
        color: rgba(0, 255, 169, 1);
        font-family: 'Digital-Serial-Regular';
        font-size: 1em;
        text-align: center;
        border: none;
        width: 100%;
    }

    .settings-input:disabled {
        background-color: transparent;
        color: rgb(73, 80, 90);
        font-family: 'Digital-Serial-Regular';
        font-size: 1em;
        text-align: center;
        border: none;
        width: 100%;
    }

    .settings-input::placeholder {
        color: rgba(0, 255, 169, 1);
        font-family: 'Digital-Serial-Regular';
    }

    .settings-input:disabled::placeholder {
        color: rgb(73, 80, 90);
    }

    hr {
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid rgba(0, 255, 169, 0.3);
        margin: 1em 0;
        padding: 0;
        width: 75%;
    }

    .small-hr {
        margin-left: 10%;
        margin-right: 10%;
    }

    h1 {
        color: rgba(0, 255, 169, 1);
        font-family: 'Digital-Serial-Bold' !important;
    }

    .permissionTable {
        margin: 5px;
        color: white;
        border: 2px solid white;
        font-family: 'Digital-Serial-Bold';
    }

    .emptyTableHeader {
        width: 300px;
        border: 2px solid white;
        text-align: center;
    }

    .tableHeader {
        border: 2px solid white;
        text-align: center;
        font-size: 1em;
        width: 100px;
    }

    .tableRow {
        border: 2px solid white;
        font-size: 1em;
    }

    .tableData {
        border: 2px solid white;
        text-align: left;
        padding-left: 5px;
    }

    .tableDataCheckBox {
        border: 2px solid white;
        text-align: center;
    }

    .modal-content {
        height: 800px;
    }

    .modal-footer {
        position: absolute;
        bottom: 0px;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/EditAccountSettings.vue